<template>
  <div class="cell" :style="style" :class="item && item.type">
    <div v-if="item">
      <div class="top">
        <div>
          <preview-link :item="item">
            {{ item.name || '[no name]' }}
          </preview-link>
        </div>
      </div>
      <div class="buttons">
        <el-checkbox-group size="mini" v-model="checks">
          <el-checkbox-button label="suggest" :disabled="!!item.blacklisted">
            <i class="fa fa-thumbs-up" aria-hidden="true"></i>
          </el-checkbox-button>
          <el-checkbox-button label="blacklist" :disabled="!!item.suggested">
            <i class="fa fa-ban" aria-hidden="true"></i>
          </el-checkbox-button>
        </el-checkbox-group>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cell {
  font-size: 0.7em;
  display: flex;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;

  &.workfolder {
    background-color: #dcdcdc;
  }

  &.track, &.videotrack, &.track, &.route {
    background-color: navy;
  }

  & > div {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
  }
}

.top {
  flex: 1 1 auto;
  min-height: 80px;

  & > div {
    background: rgba(255, 255, 255, 0.7);
    padding: 0 2px;
  }
}

.buttons {
  flex: 0 0 auto;
  padding: 3px 0;
}
</style>

<script>
import compact from 'lodash/compact'
import { CDN_URL, getPreviewUrl } from '@/utils/cdn'

import PreviewLink from './PreviewLink'

export default {
  props: ['item'],

  components: {
    PreviewLink
  },

  computed: {
    checks: {
      get: function () {
        const { suggested, blacklisted } = this.item
        const checks = compact([suggested && 'suggest', blacklisted && 'blacklist'])
        return checks
      },
      set: function (nextChecks) {
        const suggest = nextChecks.find(v => v === 'suggest')
        if (suggest !== this.checks.find(v => v === 'suggest')) {
          this.$emit('on-suggest', {
            data_name: this.item.data_name,
            type: this.item.type,
            suggested: !!suggest
          })
        }
        const blacklist = nextChecks.find(v => v === 'blacklist')
        if (blacklist !== this.checks.find(v => v === 'blacklist')) {
          this.$emit('on-blacklist', {
            data_name: this.item.data_name,
            type: this.item.type,
            blacklisted: !!blacklist
          })
        }
      }
    },
    url () {
      return this.item && getPreviewUrl(CDN_URL, this.item.type, this.item.data_name)
    },
    style () {
      return this.item && {
        'background-image': this.item.type !== 'workfolder' && `url(${this.url})`
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/suggestions/Cell.vue